@let displayAdvancedInvitationFormVal = displayAdvancedInvitationForm();
@let adminAbilities = selectedAdminAbilities();
@let canManageTellentVal = canManageTellent();

<rt-dialog-header [heading]="'tlc.members.add_member.heading' | translate" />

<rt-dialog-body variant="white">
  <form [formGroup]="formGroup" class="dialog-content">
    <div class="invitation-form-header-container">
      <div class="section-header">
        <span class="heading">{{
          'tlc.members.add_member.member_details_form.heading' | translate
        }}</span>
        <span>{{ 'tlc.members.add_member.member_details_form.subheading' | translate }}</span>
      </div>
      @if (!!kiwiApp$()) {
        <rt-button
          class="toggle-advanced-form-button"
          variant="plain"
          size="small"
          (click)="toggleAdvancedInvitationForm()"
        >
          <span>{{
            (displayAdvancedInvitationFormVal
              ? 'tlc.members.add_member.member_details_form.advanced.hide'
              : 'tlc.members.add_member.member_details_form.advanced.show'
            ) | translate
          }}</span>
          <rt-icon
            name="keyboard-arrow-down"
            class="arrow-icon"
            [class.advanced]="displayAdvancedInvitationFormVal"
          />
        </rt-button>
      }
    </div>

    <tlc-member-details-form
      [displayAdvancedForm]="displayAdvancedInvitationFormVal"
      [parentForm]="formGroup"
      (importCsvClick)="navigateToCsvImport()"
      margin-bottom-large
    />

    @switch (dialogVariant()) {
      @case (DialogVariant.Simplified) {
        <ng-container *ngTemplateOutlet="simpleViewTpl" />
      }
      @case (DialogVariant.Complex) {
        <ng-container *ngTemplateOutlet="complexViewTpl" />
      }
    }
  </form>
</rt-dialog-body>

<rt-dialog-footer variant="white">
  <rt-button (click)="close()" variant="plain">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    (click)="submit()"
    [disabled]="formGroup.invalid || !hasAtLeastOneSeatSelected()"
    [loading]="loading$()"
    variant="primary"
    >{{ 'tlc.members.add_member.add_member_cta' | translate: { count: members.length } }}
  </rt-button>
</rt-dialog-footer>

<ng-template #simpleViewTpl>
  @if (brand === TellentBrand.Recruitee) {
    <div class="section-header">
      <span class="heading">{{
        'tlc.members.add_member.roles.recruitee.heading' | translate
      }}</span>
      <span>{{ 'tlc.members.add_member.roles.recruitee.subheading' | translate }}</span>
    </div>
    <rt-form-field>
      <rt-label>{{ 'tlc.members.add_member.roles.role_label' | translate }}</rt-label>
      <rt-select
        [formControl]="seats.recruitee.controls.roleExternalId"
        [options]="recruiteeSelectOptions()"
        [emptyOptionValue]="'-'"
        [emptyOptionLabel]="'-'"
      />
    </rt-form-field>
  }
  @if (brand === TellentBrand.Kiwi) {
    <div class="section-header">
      <span class="heading">{{ 'tlc.members.add_member.roles.kiwi.heading' | translate }}</span>
      <span>{{ 'tlc.members.add_member.roles.kiwi.subheading' | translate }}</span>
    </div>
    <rt-form-field>
      <rt-select
        [formControl]="seats.kiwi.controls.roleExternalId"
        [options]="kiwiSelectOptions()"
        [emptyOptionValue]="'-'"
        [emptyOptionLabel]="'-'"
      />
    </rt-form-field>
  }
</ng-template>

<ng-template #complexViewTpl>
  <div class="access-roles">
    <div class="text">
      <span class="heading"> {{ 'tlc.members.add_member.roles.heading' | translate }}</span>
      <span [innerHTML]="'tlc.members.add_member.roles.subheading' | translate"></span>
      <div
        class="username-infobox-container"
        [class.open]="inviteMethodControl.value === InviteMethod.Login"
      >
        <rt-infobox
          class="username-infobox"
          type="information"
          iconName="info-outline"
          [isDismissible]="false"
        >
          <span>{{ 'tlc.members.add_member.username_infobox_text' | translate }}</span>
        </rt-infobox>
      </div>
    </div>

    <tlc-access-roles-table
      [recruiteeFormGroup]="seats.recruitee"
      [kiwiFormGroup]="seats.kiwi"
      [kiwiAdministratorRoleDisabled]="inviteMethodControl.value === InviteMethod.Login"
    />
  </div>
  @if (adminAbilities?.length === 0) {
    <div layout>
      <rt-button
        variant="plain"
        [disabled]="inviteMethodControl.value === InviteMethod.Login"
        (click)="openGiveAdminPermissionsDialog()"
      >
        <rt-icon prefix name="add" />
        <span>{{ 'tlc.members.add_member.give_admin_permissions' | translate }}</span>
      </rt-button>
    </div>
  } @else {
    <div class="admin-permissions-container">
      <span class="heading">{{
        'tlc.members.add_member.admin_permissions.heading' | translate
      }}</span>
      <span class="subheading">{{
        'tlc.members.add_member.admin_permissions.subheading' | translate
      }}</span>
      <tlc-edit-member-permissions-box
        [abilities]="adminAbilities"
        [canManageTellent]="canManageTellentVal"
        (actionClicked)="openGiveAdminPermissionsDialog()"
      />
    </div>
  }
</ng-template>
